import * as React from "react";
import { Chip } from "../Chip";
import { cx } from "../../helpers/utils/cx";
export const defaultRanges = [{
  label: "Last 3 days",
  key: "KALEP_DATE_RANGE_LAST_3_DAYS"
}, {
  label: "Last 7 days",
  key: "KALEP_DATE_RANGE_LAST_7_DAYS"
}, {
  label: "Last 14 days",
  key: "KALEP_DATE_RANGE_LAST_14_DAYS"
}, {
  label: "Last 30 days",
  key: "KALEP_DATE_RANGE_LAST_30_DAYS"
}, {
  label: "Next 3 days",
  key: "KALEP_DATE_RANGE_NEXT_3_DAYS"
}, {
  label: "Next 7 days",
  key: "KALEP_DATE_RANGE_NEXT_7_DAYS"
}, {
  label: "Next 14 days",
  key: "KALEP_DATE_RANGE_NEXT_14_DAYS"
}];
function getDatesFromDefaultRange(range) {
  const today = new Date();
  switch (range) {
    case "KALEP_DATE_RANGE_LAST_3_DAYS":
      return [new Date(today.getFullYear(), today.getMonth(), today.getDate() - 2), today];
    case "KALEP_DATE_RANGE_LAST_7_DAYS":
      return [new Date(today.getFullYear(), today.getMonth(), today.getDate() - 6), today];
    case "KALEP_DATE_RANGE_LAST_14_DAYS":
      return [new Date(today.getFullYear(), today.getMonth(), today.getDate() - 13), today];
    case "KALEP_DATE_RANGE_LAST_30_DAYS":
      return [new Date(today.getFullYear(), today.getMonth(), today.getDate() - 29), today];
    case "KALEP_DATE_RANGE_NEXT_3_DAYS":
      return [today, new Date(today.getFullYear(), today.getMonth(), today.getDate() + 2)];
    case "KALEP_DATE_RANGE_NEXT_7_DAYS":
      return [today, new Date(today.getFullYear(), today.getMonth(), today.getDate() + 6)];
    case "KALEP_DATE_RANGE_NEXT_14_DAYS":
      return [today, new Date(today.getFullYear(), today.getMonth(), today.getDate() + 13)];
    default:
      throw new Error(`Unknown predefined range: ${range}`);
  }
}
export function PredefinedRanges(_ref) {
  let {
    ranges,
    onRangeSelected
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: cx("flex gap-1 flex-wrap w-64 pt-2")
  }, ranges.map(range => {
    let rangeDefinition = range;
    if (typeof range === "string") {
      rangeDefinition = defaultRanges.find(r => r.key === range);
    }
    return /*#__PURE__*/React.createElement(RangeChip, {
      key: rangeDefinition.key,
      range: rangeDefinition,
      onClick: onRangeSelected
    });
  }));
}
function RangeChip(_ref2) {
  let {
    range,
    onClick
  } = _ref2;
  const selectRangeHandler = React.useCallback(() => {
    let dateRange;
    if (isCustomRangeDefinition(range)) {
      dateRange = [range.startDate, range.endDate];
    } else {
      dateRange = getDatesFromDefaultRange(range.key);
    }
    onClick(dateRange);
  }, [onClick, range]);
  return /*#__PURE__*/React.createElement(Chip, {
    size: "sm",
    label: range.label,
    onClick: selectRangeHandler
  });
}
function isCustomRangeDefinition(range) {
  return range.startDate !== undefined;
}